import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
type State = {
    count: number;
    coeff: number[];
    field: number[][];
    revealed: number[];
    randomSeed: string;
    hash: string;
}
export const useStairsSocket = (rootPath) => {
    const EMIT_STAIRS_BET = async (
        data: {
            amount?: string;
            type: number; // 0=prebet, 1=bet, 2=提现 
            revealed?: number[] // only type be 1 will pass in ;
            count?: number // it set up game level max is 7 min is 1
            frontID?: number;
            isFast?: boolean;
        },
        callback?: (res: any) => any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return await asyncEmit<{
            _id: number;
            amount: string;
            balanceBefore: string;
            currency: string;
            multi: number;
            state: State;
            status: string;
            user: number;
            winAmount: number;
            hash: string;
            userInfo: Object;
            timestamp: string;
            [key: string]: any; // 前端将追加其它值
        }>(`${rootPath}.stairs.bet`, data);
    };

    return {
        EMIT_STAIRS_BET,
    };
};